import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import referenceService from "services/Setup/Master/referenceService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  referenceList: {},
  getCount: 0,

  SupplierTypeList: [],
  SupplierCategoryList: [],
  SupplierStatusList: [],
  AgencyTypeList: [],
  AgencyCategoryList: [],
  AgencyStatusList: [],
  AgencyEmployeePositionList: [],
  BranchList: [],
  GenderList: [{ code: "", name: "" }],
  IdTypeList: [{ code: "", name: "" }],
  AddressTypeList: [],
  MaritalStatusList: [{ code: "", name: "" }],
  NationalityList: [{ code: "", name: "" }],
  CustomerTypeList: [],
  PersonalCustomerTypeList: [],
  CustomerStatusList: [],
  SourceApplicationList: [],
  CurrencyList: [],
  AcquisitionTypeList: [],
  ProspectStepList: [],
  ScreeningDecisionList: [],
  ReasonList: [],
  HomeLocationList: [],
  Firstinstallment: [],
  Interestcalcmethod: [],
  TaxIdList: [],
  surveyTypeList: [],

  interestTypeList: [],
  assetTypeList: [],
  idTypeList: [],
  GenderList2: [],
  financeSchemeList: [],
  SupplierStatus: [],
  SupplierCategory: [],
  ApplicationTypeList: [],
  EventPromoList: [],
  financeTypeList: [],
  MasterBank: [],
  lineofBusinessList: [],
  SourceApplicationList2: [],
  CustomerList: [],
  wayOfPaymentList: [],
  RojksegmenfasilitasList: [],
  assetGradeList: [],
  serviceTypeList: [],
  interestSchemeList: [],
  interestCalcMethodList: [],
  interestcalcmethodList: [],
  installMentSchemeList: [],
  productDocumentList: [],
  interestRateOfferList: [],
  paymentFrequency: [],
  insCoverBy: [],
  optionCollAmount: [],
  collateralStatus: [],
  rojkCategoryDebitur: [],
  repaymentType: [],
  ROJKKreditPemerintah: [],
  statusrumahList: [],
  approvalStepList: [],
  stepupstepdowntypeList: [],
  downPaymentPaidList: [],
  tipepencairanList: [],
  disbursementtoList: [],
  usagePolicyList: [],
  codePlatList: [],
  systemDate: [],
  karoseriTypesList: [],
  periodCoverList: [],
  graceperiodtypeList: [],
  employePositionList: [],
  surveyLocationList: [],
  checkSocialAspectList: [],
  relationWithSalesList: [],
  businessAddressFlagList: [],
  bpkbIssuedByList: [],
  homeConditionList: [],
  homeFurnishingsList: [],
  roadConditionHomeList: [],
  environmentalConditionsList: [],
  officeLocationList: [],
  bankIdList: [],
  accountTypeList: [],
  carecomendationList: [],

  dayMonthList: [],
  assetConditionList: [],
  penggunaanDanaTunaiList: [],
  insCoverageTypeList: [],
  getInsPaidByList: [],
  agencyemployeepositionList: [],
  refLoanAssessmentItemValueList: [],
  paymentTermList: [],
  refInvoiceDisbDocList: [],

  BankAccountTypeList: [],
  AccountPurposeList: [],
  EBankingConnectList: [],
  ResetFlagList: [],

  pekerjaanList: [],
  aoOrCmo: [
    {
      name: "Andi",
      code: "AO0001",
    },
    {
      name: "Doni",
      code: "AO0002",
    },
  ],
  documentStatusList : [],
  rcvFromList:[],
};

export const getSupplierTypeList = createAsyncThunk(
  "reference/getSupplierTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getSupplierTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getSupplierCategoryList = createAsyncThunk(
  "reference/getSupplierCategoryList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getSupplierCategoryList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getSupplierStatusList = createAsyncThunk(
  "reference/getSupplierStatusList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getSupplierStatusList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAgencyTypeList = createAsyncThunk(
  "reference/getAgencyTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getAgencyTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAgencyCategoryList = createAsyncThunk(
  "reference/getAgencyCategoryList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getAgencyCategoryList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAgencyStatusList = createAsyncThunk(
  "reference/getAgencyStatusList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getAgencyStatusList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAgencyEmployeePositionList = createAsyncThunk(
  "reference/getAgencyEmployeePositionList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getAgencyEmployeePositionList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getBranchList = createAsyncThunk(
  "reference/getBranchList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getBranchList(data);
      console.log("🚀 ~ response:getBranchList", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getGenderList = createAsyncThunk(
  "reference/getGenderList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getGenderList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getIdTypeList = createAsyncThunk(
  "reference/getIdTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getIdTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAddressTypeList = createAsyncThunk(
  "reference/getAddressTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getAddressTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getMaritalStatusList = createAsyncThunk(
  "reference/getMaritalStatusList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getMaritalStatusList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getNationalityList = createAsyncThunk(
  "reference/getNationalityList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getNationalityList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getCustomerTypeList = createAsyncThunk(
  "reference/getCustomerTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getCustomerTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getPersonalCustomerTypeList = createAsyncThunk(
  "reference/getPersonalCustomerTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getPersonalCustomerTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getCustomerStatusList = createAsyncThunk(
  "reference/getCustomerStatusList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getCustomerStatusList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getSourceApplicationList = createAsyncThunk(
  "reference/getSourceApplicationList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getSourceApplicationList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getCurrencyList = createAsyncThunk(
  "reference/getCurrencyList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getCurrencyList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAcquisitionTypeList = createAsyncThunk(
  "reference/getAcquisitionTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getAcquisitionTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getProspectStepList = createAsyncThunk(
  "reference/getProspectStepList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getProspectStepList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getScreeningDecisionList = createAsyncThunk(
  "reference/getScreeningDecisionList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getScreeningDecisionList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getReasonList = createAsyncThunk(
  "reference/getReasonList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getReasonList(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getHomeLocationList = createAsyncThunk(
  "reference/getHomeLocationList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getHomeLocationList(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

//Santani Working On Supplier Modul
export const interestType = createAsyncThunk(
  "reference/interestType",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ response:interestType");
    try {
      const response = await referenceService.interestType();
      console.log("🚀 ~ response:interestType", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:interestType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const assetType = createAsyncThunk(
  "reference/assetType",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataassetType:", data);
    try {
      const response = await referenceService.assetType();
      console.log("🚀 ~ responseassetType:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const financeScheme = createAsyncThunk(
  "reference/financeScheme",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ datafinanceScheme:", data);
    try {
      const response = await referenceService.financeScheme();
      console.log("🚀 ~ responsefinanceScheme:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const idType = createAsyncThunk(
  "reference/idType",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataidType:", data);
    try {
      const response = await referenceService.idType();
      console.log("🚀 ~ responseidType:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectGender = createAsyncThunk(
  "reference/SelectGender",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectGender:", data);
    try {
      const response = await referenceService.SelectGender();
      console.log("🚀 ~ responseSelectGender:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectSupplierStatusSlice = createAsyncThunk(
  "reference/SelectSupplierStatusSlice",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectSupplierStatusSlice:", data);
    try {
      const response = await referenceService.SupplierStatus();
      console.log("🚀 ~ responseSelectSupplierStatusSlice:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:SelectSupplierStatusSlice error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectSupplierCategorySlice = createAsyncThunk(
  "reference/SelectSupplierCategorySlice",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectSupplierCategorySlice:", data);
    try {
      const response = await referenceService.SupplierCategory();
      console.log("🚀 ~ responseSelectSupplierCategorySlice:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectApplicationType = createAsyncThunk(
  "reference/SelectApplicationType",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectApplicationType:", data);
    try {
      const response = await referenceService.SelectApplicationType();
      console.log("🚀 ~ responseSelectApplicationType:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectEventPromo = createAsyncThunk(
  "reference/SelectEventPromo",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectEventPromo:", data);
    try {
      const response = await referenceService.SelectEventPromo();
      console.log("🚀 ~ responseSelectEventPromo:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectSourceApplication = createAsyncThunk(
  "reference/SelectSourceApplication",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectSourceApplication:", data);
    try {
      const response = await referenceService.SelectSourceApplication();

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getFinanceType = createAsyncThunk(
  "reference/getFinanceType",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ datagetFinanceType:", data);
    try {
      const response = await referenceService.getFinanceType();
      console.log("🚀 ~ responsegetFinanceType:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectMasterBank = createAsyncThunk(
  "reference/SelectMasterBank",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectMasterBank:", data);
    try {
      const response = await referenceService.SelectMasterBank();

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectMasterBankSearch = createAsyncThunk(
  "reference/SelectMasterBankSearch",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectMasterBankSearch:", data);
    try {
      const response = await referenceService.SelectMasterBankSearch(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getLineofBusinessList = createAsyncThunk(
  "reference/getLineofBusinessList",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ datagetLineofBusinessList:", data);
    try {
      const response = await referenceService.getLineofBusinessList(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectCustomer = createAsyncThunk(
  "reference/SelectCustomer",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectCustomer:", data);
    try {
      const response = await referenceService.SelectCustomer(data);
      console.log("responsedataSelectCustomer", response.data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SearchCustomerByNameAndAddress = createAsyncThunk(
  "reference/getsubproductOfferingSerch",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSearchCustomerByNameAndAddress:", data);
    try {
      const response =
        await referenceService.SearchCustomerByNameAndAddress(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const SelectWayOfPaymentSlice = createAsyncThunk(
  "reference/SelectWayOfPaymentSlice",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ dataSelectWayOfPayment:", data);
    try {
      const response = await referenceService.SelectWayOfPaymentService(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetRojksegmenfasilitas = createAsyncThunk(
  "reference/GetRojksegmenfasilitas",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ rejectWithValue:", rejectWithValue);
    try {
      const response = await referenceService.GetRojksegmenfasilitas(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetAssetGrade = createAsyncThunk(
  "reference/GetAssetGrade",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetAssetGrade(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetInterestCalcMethod = createAsyncThunk(
  "reference/GetInterestCalcMethod",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetInterestCalcMethod(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetServiceType = createAsyncThunk(
  "reference/GetServiceType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetServiceType(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetInterestScheme = createAsyncThunk(
  "reference/GetInterestScheme",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetInterestScheme(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetInstallMentScheme = createAsyncThunk(
  "reference/GetInstallMentScheme",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetInstallMentScheme(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetInsPaidBy = createAsyncThunk(
  "reference/GetInsPaidBy",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetInsPaidBy(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const productDocument = createAsyncThunk(
  "reference/productDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.productDocument();
      console.log("🚀 ~ responseproductDocument:", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetInterestRateOffer = createAsyncThunk(
  "reference/GetInterestRateOffer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetInterestRateOffer(data);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:assetType error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetPaymentfrequency = createAsyncThunk(
  "reference/GetPaymentfrequency",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetPaymentfrequency(data);

      console.log("responseGetPaymentfrequency", response);

      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 response:responseGetPaymentfrequency error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getDayMonth = createAsyncThunk(
  "reference/getDayMonth",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetDayMonth(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAssetCondition = createAsyncThunk(
  "reference/getAssetCondition",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetAssetCondition(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetSurveyType = createAsyncThunk(
  "reference/GetSurveyType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetSurveyType(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getPekerjaanList = createAsyncThunk(
  "reference/getPekerjaanList",
  async (data, { rejectWithValue }) => {
    console.log("getPekerjaanList slice", data);
    try {
      const response = await referenceService.GetKodePekerjaan(data);
      console.log("getPekerjaanList response", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetEmployePosition = createAsyncThunk(
  "reference/GetEmployePosition",
  async (data, { rejectWithValue }) => {
    console.log("GetEmployePosition slice", data);
    try {
      const response = await referenceService.GetEmployePosition(data);
      console.log("GetEmployePosition response", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getPenggunaanDanaTunai = createAsyncThunk(
  "reference/getPenggunaanDanaTunai",
  async (data, { rejectWithValue }) => {
    console.log("getPekerjaanList slice", data);
    try {
      const response = await referenceService.GetPenggunaanDanaTunai();
      console.log("getPenggunaanDanaTunai response", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getInsCoverageType = createAsyncThunk(
  "reference/getInsCoverageType",
  async (data, { rejectWithValue }) => {
    console.log("getPekerjaanList responsettt", data);
    try {
      const response = await referenceService.GetInsCoverageType(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getInsCoverBy = createAsyncThunk(
  "reference/getInsCoverBy",
  async (data, { rejectWithValue }) => {
    console.log("getPekerjaanList responsettt", data);
    try {
      const response = await referenceService.GetInsCoverBy(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetFirstinstallment = createAsyncThunk(
  "reference/GetFirstinstallment",
  async (data, { rejectWithValue }) => {
    console.log("getPekerjaanList responsettt", data);
    try {
      const response = await referenceService.GetFirstinstallment(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getTaxIdList = createAsyncThunk(
  "reference/getTaxIdList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getTaxIdList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetAgencyemployeepositionSlice = createAsyncThunk(
  "reference/GetAgencyemployeepositionSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await referenceService.GetAgencyemployeepositionService(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const OptionCollAmountSlice = createAsyncThunk(
  "reference/OptionCollAmountSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.OptionCollAmountService(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const CollateralStatusSlice = createAsyncThunk(
  "reference/CollateralStatusSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.CollateralStatusService(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const RepaymentTypeSlice = createAsyncThunk(
  "reference/RepaymentTypeSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetRepaymentTypeService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetRojkcategorydebitur = createAsyncThunk(
  "reference/GetRojkcategorydebitur",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetRojkcategorydebitur(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetROJKrKeditPemerintahSlice = createAsyncThunk(
  "reference/GetROJKKreditPemerintahSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await referenceService.GetROJKKreditPemerintahService(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetROJKKreditPemerintahSlice = createAsyncThunk(
  "reference/GetROJKKreditPemerintahSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await referenceService.GetROJKKreditPemerintahService(data);
      console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetStatusrumahSlice = createAsyncThunk(
  "reference/GetStatusrumahSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetStatusrumahService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetApprovalStepSlice = createAsyncThunk(
  "reference/GetApprovalStepSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetApprovalStepService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetStepupstepdowntypeSlice = createAsyncThunk(
  "reference/GetStepupstepdowntypeSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await referenceService.GetStepupstepdowntypeService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetDownPaymentPaidSlice = createAsyncThunk(
  "reference/GetDownPaymentPaidSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetDownPaymentPaidService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetTipepencairanSLice = createAsyncThunk(
  "reference/GetTipepencairanSLice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetTipepencairanService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetDisbursementToSlice = createAsyncThunk(
  "reference/GetDisbursementToSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetDisbursementToService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetUsagePolicySlice = createAsyncThunk(
  "reference/GetUsagePolicySlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetUsagePolicyService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getCodePlatSlice = createAsyncThunk(
  "reference/getCodePlatSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetcodePlatService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getSystemDateSlice = createAsyncThunk(
  "reference/getSystemDateSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetSystemDateService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getKaroseriTypesSlice = createAsyncThunk(
  "reference/getKaroseriTypesSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetKaroseriTypesService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getPeriodCoverSlice = createAsyncThunk(
  "reference/getPeriodCoverSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetPeriodCoverService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetGraceperiodtypeSlice = createAsyncThunk(
  "reference/GetGraceperiodtypeSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetGraceperiodtypeService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetSurveyLocationSlice = createAsyncThunk(
  "reference/GetSurveyLocationSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetSurveyLocationService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetCheckSocialAspectSlice = createAsyncThunk(
  "reference/GetCheckSocialAspectSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetCheckSocialAspectService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetRelationWithSalesSlice = createAsyncThunk(
  "reference/GetRelationWithSalesSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetRelationWithSalesService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetBusinessAddressFlagSlice = createAsyncThunk(
  "reference/GetBusinessAddressFlagSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await referenceService.GetBusinessAddressFlagService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetBpkbIssuedBySlice = createAsyncThunk(
  "reference/GetBpkbIssuedBySlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetBpkbIssuedByService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetHomeConditionSlice = createAsyncThunk(
  "reference/GetHomeConditionSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetHomeConditionService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetHomeFurnishingsSlice = createAsyncThunk(
  "reference/GetHomeFurnishingsSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetHomeFurnishingsService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetRoadConditionHomeSlice = createAsyncThunk(
  "reference/GetRoadConditionHomeSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetRoadConditionHomeService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetEnvironmentalConditionsSlice = createAsyncThunk(
  "reference/GetEnvironmentalConditionsSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await referenceService.GetEnvironmentalConditionsService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetOfficeLocationSlice = createAsyncThunk(
  "reference/GetOfficeLocationSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetOfficeLocationService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetBankIdSlice = createAsyncThunk(
  "reference/GetBankIdSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetBankIdService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetAccountTypeSlice = createAsyncThunk(
  "reference/GetAccountTypeSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetaccountTypeService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetRefLoanAssessmentItemValueSlice = createAsyncThunk(
  "reference/GetRefLoanAssessmentItemValueSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await referenceService.GetRefLoanAssessmentItemValueService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const GetCarecomendationSlice = createAsyncThunk(
  "reference/GetCarecomendationSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.GetCarecomendationService(data);
      // console.log("getPekerjaanList responsettt", response);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("getPekerjaanList responsettt", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getPaymentTerm = createAsyncThunk(
  "reference/getPaymentTerm",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getPaymentTerm(data);
      if (response) {
        return response;
      } else {
        return { status: "OK", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getRefInvoiceDisbDoc = createAsyncThunk(
  "reference/getRefInvoiceDisbDoc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getRefInvoiceDisbDoc(data);
      if (response) {
        return response;
      } else {
        return { status: "OK", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getBankAccountType = createAsyncThunk(
  "reference/getBankAccountType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getBankAccountType(data);
      if (response) {
        return response;
      } else {
        return { status: "OK", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getAccountPurpose = createAsyncThunk(
  "reference/getAccountPurpose",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getAccountPurpose(data);
      if (response) {
        return response;
      } else {
        return { status: "OK", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getEBankingConnect = createAsyncThunk(
  "reference/getEBankingConnect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getEBankingConnect(data);
      if (response) {
        return response;
      } else {
        return { status: "OK", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

export const getResetFlag = createAsyncThunk(
  "reference/getResetFlag",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getResetFlag(data);
      if (response) {
        return response;
      } else {
        return { status: "OK", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  },
);

// collateral reference 08062026 by triut
export const getDocumentStatus = createAsyncThunk(
  "reference/getDocumentStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getDocumentStatus();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getRcvFromCollateral = createAsyncThunk(
  "reference/getRcvFromCollateral",
  async (data, { rejectWithValue }) => {
    try {
      const response = await referenceService.getRcvFromCollateral();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
// end collateral reference

export const reference = createSlice({
  name: "reference",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    tesAlert: (state) => {
      state.message += "11-";
      console.log("qwertyuiop", state.message);
    },
  },

  extraReducers: (builder) => {
    builder
      //Ilham Working

      //SupplierTypeList
      .addCase(getSupplierTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSupplierTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.SupplierTypeList = action.payload.data;
      })
      .addCase(getSupplierTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //SupplierCategoryList
      .addCase(getSupplierCategoryList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSupplierCategoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.SupplierCategoryList = action.payload.data;
      })
      .addCase(getSupplierCategoryList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //SupplierStatusList
      .addCase(getSupplierStatusList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSupplierStatusList.fulfilled, (state, action) => {
        state.loading = false;
        state.SupplierStatusList = action.payload.data;
      })
      .addCase(getSupplierStatusList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AgencyTypeList
      .addCase(getAgencyTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAgencyTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.AgencyTypeList = action.payload.data;
      })
      .addCase(getAgencyTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AgencyCategoryList
      .addCase(getAgencyCategoryList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAgencyCategoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.AgencyCategoryList = action.payload.data;
      })
      .addCase(getAgencyCategoryList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AgencyStatusList
      .addCase(getAgencyStatusList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAgencyStatusList.fulfilled, (state, action) => {
        state.loading = false;
        state.AgencyStatusList = action.payload.data;
      })
      .addCase(getAgencyStatusList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AgencyEmployeePositionList
      .addCase(getAgencyEmployeePositionList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAgencyEmployeePositionList.fulfilled, (state, action) => {
        state.loading = false;
        state.AgencyEmployeePositionList = action.payload.data;
      })
      .addCase(getAgencyEmployeePositionList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //BranchList
      .addCase(getBranchList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getBranchList.fulfilled, (state, action) => {
        state.loading = false;
        state.BranchList = action.payload.data;
      })
      .addCase(getBranchList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GenderList
      .addCase(getGenderList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getGenderList.fulfilled, (state, action) => {
        state.loading = false;
        state.GenderList = action.payload.data;
      })
      .addCase(getGenderList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //IdTypeList
      .addCase(getIdTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getIdTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.IdTypeList = action.payload.data;
      })
      .addCase(getIdTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AddressTypeList
      .addCase(getAddressTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAddressTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.AddressTypeList = action.payload.data;
      })
      .addCase(getAddressTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //MaritalStatusList
      .addCase(getMaritalStatusList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMaritalStatusList.fulfilled, (state, action) => {
        state.loading = false;
        state.MaritalStatusList = action.payload.data;
      })
      .addCase(getMaritalStatusList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //NationalityList
      .addCase(getNationalityList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getNationalityList.fulfilled, (state, action) => {
        state.loading = false;
        state.NationalityList = action.payload.data;
      })
      .addCase(getNationalityList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CustomerTypeList
      .addCase(getCustomerTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCustomerTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerTypeList = action.payload.data;
      })
      .addCase(getCustomerTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //PersonalCustomerTypeList
      .addCase(getPersonalCustomerTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.PersonalCustomerTypeList = action.payload.data;
      })
      .addCase(getPersonalCustomerTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CustomerStatusList
      .addCase(getCustomerStatusList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCustomerStatusList.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerStatusList = action.payload.data;
      })
      .addCase(getCustomerStatusList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //SourceApplicationList
      .addCase(getSourceApplicationList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSourceApplicationList.fulfilled, (state, action) => {
        state.loading = false;
        state.SourceApplicationList = action.payload.data;
      })
      .addCase(getSourceApplicationList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CurrencyList
      .addCase(getCurrencyList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCurrencyList.fulfilled, (state, action) => {
        state.loading = false;
        state.CurrencyList = action.payload.data;
      })
      .addCase(getCurrencyList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AcquisitionTypeList
      .addCase(getAcquisitionTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAcquisitionTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.AcquisitionTypeList = action.payload.data;
      })
      .addCase(getAcquisitionTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //ProspectStepList
      .addCase(getProspectStepList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProspectStepList.fulfilled, (state, action) => {
        state.loading = false;
        state.ProspectStepList = action.payload.data;
      })
      .addCase(getProspectStepList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //ScreeningDecisionList
      .addCase(getScreeningDecisionList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getScreeningDecisionList.fulfilled, (state, action) => {
        state.loading = false;
        state.ScreeningDecisionList = action.payload.data;
      })
      .addCase(getScreeningDecisionList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //ReasonList
      .addCase(getReasonList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getReasonList.fulfilled, (state, action) => {
        state.loading = false;
        state.ReasonList = action.payload.data;
      })
      .addCase(getReasonList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //HomeLocationList
      .addCase(getHomeLocationList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getHomeLocationList.fulfilled, (state, action) => {
        state.loading = false;
        state.HomeLocationList = action.payload.data;
      })
      .addCase(getHomeLocationList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //Santani Working On Supplier Modul

      //interestType list
      .addCase(interestType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(interestType.fulfilled, (state, action) => {
        state.loading = false;
        state.interestTypeList = action.payload.data;
      })
      .addCase(interestType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //assetType list
      .addCase(assetType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(assetType.fulfilled, (state, action) => {
        state.loading = false;
        state.assetTypeList = action.payload.data.data;
      })
      .addCase(assetType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //financeScheme list
      .addCase(financeScheme.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(financeScheme.fulfilled, (state, action) => {
        state.loading = false;
        state.financeSchemeList = action.payload.data;
      })
      .addCase(financeScheme.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //id type list
      .addCase(idType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(idType.fulfilled, (state, action) => {
        state.loading = false;
        state.idTypeList = action.payload.data;
      })
      .addCase(idType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //SelectGender list
      .addCase(SelectGender.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectGender.fulfilled, (state, action) => {
        state.loading = false;
        state.GenderList2 = action.payload.data;
      })
      .addCase(SelectGender.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // SelectSupplierStatusSlice
      .addCase(SelectSupplierStatusSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectSupplierStatusSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.SupplierStatus = action.payload.data;
      })
      .addCase(SelectSupplierStatusSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // SelectSupplierCategorySlice
      .addCase(SelectSupplierCategorySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectSupplierCategorySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.SupplierCategory = action.payload.data;
      })
      .addCase(SelectSupplierCategorySlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // SelectApplicationType
      .addCase(SelectApplicationType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectApplicationType.fulfilled, (state, action) => {
        state.loading = false;
        state.ApplicationTypeList = action.payload.data;
      })
      .addCase(SelectApplicationType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // SelectEventPromo
      .addCase(SelectEventPromo.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectEventPromo.fulfilled, (state, action) => {
        state.loading = false;
        state.EventPromoList = action.payload.data;
      })
      .addCase(SelectEventPromo.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // SelectSourceApplication
      .addCase(SelectSourceApplication.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectSourceApplication.fulfilled, (state, action) => {
        state.loading = false;
        state.SourceApplicationList2 = action.payload.data;
      })
      .addCase(SelectSourceApplication.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // getFinanceType
      .addCase(getFinanceType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getFinanceType.fulfilled, (state, action) => {
        state.loading = false;
        state.financeTypeList = action.payload.data;
      })
      .addCase(getFinanceType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // SelectMasterBank
      .addCase(SelectMasterBank.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectMasterBank.fulfilled, (state, action) => {
        state.loading = false;
        state.MasterBank = action.payload.data;
      })
      .addCase(SelectMasterBank.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // SelectMasterBankSearch
      .addCase(SelectMasterBankSearch.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectMasterBankSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.MasterBank = action.payload.data.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(SelectMasterBankSearch.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;

        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetEmployePosition
      .addCase(GetEmployePosition.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetEmployePosition.fulfilled, (state, action) => {
        state.loading = false;
        state.employePositionList = action.payload.data.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(GetEmployePosition.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;

        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //
      .addCase(getLineofBusinessList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getLineofBusinessList.fulfilled, (state, action) => {
        // console.log(
        //   "🚀 ~ .addCasegetLineofBusinessList ~ action:",
        //   action.payload.data
        // );
        state.loading = false;
        state.lineofBusinessList = action.payload.data;
      })
      .addCase(getLineofBusinessList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //
      .addCase(SelectCustomer.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectCustomer.fulfilled, (state, action) => {
        // console.log('action.payload.data.data',action.payload.data.data);

        state.loading = false;
        state.CustomerList = action.payload.data.data;
      })
      .addCase(SelectCustomer.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //
      .addCase(SearchCustomerByNameAndAddress.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SearchCustomerByNameAndAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerList = action.payload.data.data;
      })
      .addCase(SearchCustomerByNameAndAddress.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //
      .addCase(SelectWayOfPaymentSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(SelectWayOfPaymentSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.wayOfPaymentList = action.payload.data;
      })
      .addCase(SelectWayOfPaymentSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //
      .addCase(GetRojksegmenfasilitas.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetRojksegmenfasilitas.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCaseRojksegmenfasilitas ~ action:", action);
        state.loading = false;
        state.RojksegmenfasilitasList = action.payload.data;
      })
      .addCase(GetRojksegmenfasilitas.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetAssetGrade
      .addCase(GetAssetGrade.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetAssetGrade.fulfilled, (state, action) => {
        console.log("🚀 ~ .assetGradeList ~ action:", action);
        state.loading = false;
        state.assetGradeList = action.payload.data;
      })
      .addCase(GetAssetGrade.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetServiceType
      .addCase(GetServiceType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetServiceType.fulfilled, (state, action) => {
        console.log("🚀 ~ .assetGradeList ~ action:", action);
        state.loading = false;
        state.serviceTypeList = action.payload.data;
      })
      .addCase(GetServiceType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetInterestScheme
      .addCase(GetInterestScheme.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetInterestScheme.fulfilled, (state, action) => {
        console.log("🚀 ~ .assetGradeList ~ action:", action);
        state.loading = false;
        state.interestSchemeList = action.payload.data;
      })
      .addCase(GetInterestScheme.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetInterestCalcMethod
      .addCase(GetInterestCalcMethod.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetInterestCalcMethod.fulfilled, (state, action) => {
        state.loading = false;
        state.interestcalcmethodList = action.payload.data;
      })
      .addCase(GetInterestCalcMethod.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetInstallMentScheme
      .addCase(GetInstallMentScheme.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetInstallMentScheme.fulfilled, (state, action) => {
        state.loading = false;
        state.installMentSchemeList = action.payload.data;
      })

      .addCase(GetInstallMentScheme.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //productDocument type
      .addCase(productDocument.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(productDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.productDocumentList = action.payload.data;
      })
      .addCase(productDocument.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetInterestRateOffer
      .addCase(GetInterestRateOffer.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetInterestRateOffer.fulfilled, (state, action) => {
        state.loading = false;
        state.interestRateOfferList = action.payload.data;
      })
      .addCase(GetInterestRateOffer.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetPaymentfrequency
      .addCase(GetPaymentfrequency.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetPaymentfrequency.fulfilled, (state, action) => {
        console.log("actionGetPaymentfrequency", action);

        state.loading = false;
        state.paymentFrequency = action.payload.data;
      })

      .addCase(GetPaymentfrequency.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //getDayMonth
      .addCase(getDayMonth.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getDayMonth.fulfilled, (state, action) => {
        console.log("actiongetDayMonth", action);

        state.loading = false;
        state.dayMonthList = action.payload.data;
      })

      .addCase(getDayMonth.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getAssetCondition
      .addCase(getAssetCondition.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetCondition.fulfilled, (state, action) => {
        console.log("actiongetAssetCondition", action);

        state.loading = false;
        state.assetConditionList = action.payload.data;
      })

      .addCase(getAssetCondition.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //GetSurveyType
      .addCase(GetSurveyType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetSurveyType.fulfilled, (state, action) => {
        console.log("actionGetSurveyType", action);

        state.loading = false;
        state.surveyTypeList = action.payload.data;
      })

      .addCase(GetSurveyType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //getPenggunaanDanaTunai
      .addCase(getPenggunaanDanaTunai.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPenggunaanDanaTunai.fulfilled, (state, action) => {
        console.log("actiongetPenggunaanDanaTunai", action);

        state.loading = false;
        state.penggunaanDanaTunaiList = action.payload.data;
      })

      //getInsCoverageType
      .addCase(getInsCoverageType.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })

      .addCase(getInsCoverageType.fulfilled, (state, action) => {
        state.loading = false;
        state.insCoverageTypeList = action.payload.data;
      })

      .addCase(getInsCoverageType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //getInsCoverBy
      .addCase(getInsCoverBy.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })

      .addCase(getInsCoverBy.fulfilled, (state, action) => {
        state.loading = false;
        state.insCoverBy = action.payload.data;
      })

      .addCase(getInsCoverBy.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //GetFirstinstallment
      .addCase(GetFirstinstallment.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })

      .addCase(GetFirstinstallment.fulfilled, (state, action) => {
        state.loading = false;
        state.Firstinstallment = action.payload.data;
      })

      .addCase(GetFirstinstallment.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //getPekerjaanList
      .addCase(getPekerjaanList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPekerjaanList.fulfilled, (state, action) => {
        console.log("actiongetPekerjaanList", action);

        state.loading = false;
        state.pekerjaanList = action.payload.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getPekerjaanList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //getInsPaidByList
      .addCase(GetInsPaidBy.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetInsPaidBy.fulfilled, (state, action) => {
        console.log("actionGetInsPaidBy", action);

        state.loading = false;
        state.getInsPaidByList = action.payload.data;
        state.getCount = action.payload.data.count;
      })

      .addCase(GetInsPaidBy.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //TaxIdList
      .addCase(getTaxIdList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getTaxIdList.fulfilled, (state, action) => {
        state.loading = false;
        state.TaxIdList = action.payload.data;
      })
      .addCase(getTaxIdList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CollateralStatusSlice
      .addCase(CollateralStatusSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(CollateralStatusSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.collateralStatus = action.payload.data;
      })
      .addCase(CollateralStatusSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //GetAgencyemployeepositionSlice
      .addCase(GetAgencyemployeepositionSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetAgencyemployeepositionSlice.fulfilled, (state, action) => {
        console.log("actionGetAgencyemployeepositionSlice", action);

        state.loading = false;
        state.agencyemployeepositionList = action.payload.data;
      })

      .addCase(GetAgencyemployeepositionSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //OptionCollAmountSlice
      .addCase(OptionCollAmountSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(OptionCollAmountSlice.fulfilled, (state, action) => {
        console.log("actionOptionCollAmountSlice", action);

        state.loading = false;
        state.optionCollAmount = action.payload.data;
      })

      .addCase(OptionCollAmountSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetRojkcategorydebitur
      .addCase(GetRojkcategorydebitur.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetRojkcategorydebitur.fulfilled, (state, action) => {
        console.log("actionGetRojkcategorydebitur", action);

        state.loading = false;
        state.rojkCategoryDebitur = action.payload.data;
      })

      .addCase(GetRojkcategorydebitur.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //RepaymentTypeSlice
      .addCase(RepaymentTypeSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(RepaymentTypeSlice.fulfilled, (state, action) => {
        console.log("actionRepaymentTypeSlice", action);

        state.loading = false;
        state.repaymentType = action.payload.data;
      })

      .addCase(RepaymentTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetROJKKreditPemerintahSlice
      .addCase(GetROJKKreditPemerintahSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetROJKKreditPemerintahSlice.fulfilled, (state, action) => {
        // console.log("actionGetROJKKreditPemerintahSlice", action);

        state.loading = false;
        state.ROJKKreditPemerintah = action.payload.data;
      })

      .addCase(GetROJKKreditPemerintahSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetStatusrumahSlice
      .addCase(GetStatusrumahSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetStatusrumahSlice.fulfilled, (state, action) => {
        // console.log("actionGetStatusrumahSlice", action);

        state.loading = false;
        state.statusrumahList = action.payload.data;
      })

      .addCase(GetStatusrumahSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetStatusrumahSlice
      .addCase(GetApprovalStepSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetApprovalStepSlice.fulfilled, (state, action) => {
        // console.log("actionGetApprovalStepSlice", action);

        state.loading = false;
        state.approvalStepList = action.payload.data;
      })

      .addCase(GetApprovalStepSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetStatusrumahSlice
      .addCase(GetStepupstepdowntypeSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetStepupstepdowntypeSlice.fulfilled, (state, action) => {
        // console.log("actionGetStepupstepdowntypeSlice", action);

        state.loading = false;
        state.stepupstepdowntypeList = action.payload.data;
      })

      .addCase(GetStepupstepdowntypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetDownPaymentPaidSlice
      .addCase(GetDownPaymentPaidSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetDownPaymentPaidSlice.fulfilled, (state, action) => {
        // console.log("actionGetDownPaymentPaidSlice", action);

        state.loading = false;
        state.downPaymentPaidList = action.payload.data;
      })

      .addCase(GetDownPaymentPaidSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetTipepencairanSLice
      .addCase(GetTipepencairanSLice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetTipepencairanSLice.fulfilled, (state, action) => {
        console.log("actionGetTipepencairanSLice", action.payload.data);

        state.loading = false;
        state.tipepencairanList = action.payload.data;
      })

      .addCase(GetTipepencairanSLice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetDisbursementToSlice
      .addCase(GetDisbursementToSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetDisbursementToSlice.fulfilled, (state, action) => {
        console.log("actionGetDisbursementToSlice", action.payload.data);

        state.loading = false;
        state.disbursementtoList = action.payload.data;
      })

      .addCase(GetDisbursementToSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetDisbursementToSlice
      .addCase(GetUsagePolicySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetUsagePolicySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.usagePolicyList = action.payload.data;
      })

      .addCase(GetUsagePolicySlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetDisbursementToSlice
      .addCase(getCodePlatSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCodePlatSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.codePlatList = action.payload.data;
      })

      .addCase(getCodePlatSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetDisbursementToSlice
      .addCase(getSystemDateSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSystemDateSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.systemDate = action.payload.data;
      })

      .addCase(getSystemDateSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetKaroseriTypesService
      .addCase(getKaroseriTypesSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getKaroseriTypesSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.karoseriTypesList = action.payload.data;
      })

      .addCase(getKaroseriTypesSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //getPeriodCoverSlice
      .addCase(getPeriodCoverSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPeriodCoverSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.periodCoverList = action.payload.data;
      })

      .addCase(getPeriodCoverSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetGraceperiodtypeSlice
      .addCase(GetGraceperiodtypeSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetGraceperiodtypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.graceperiodtypeList = action.payload.data;
      })

      .addCase(GetGraceperiodtypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetSurveyLocationSlice
      .addCase(GetSurveyLocationSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetSurveyLocationSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.surveyLocationList = action.payload.data;
      })

      .addCase(GetSurveyLocationSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //GetCheckSocialAspectSlice
      .addCase(GetCheckSocialAspectSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetCheckSocialAspectSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.checkSocialAspectList = action.payload.data;
      })
      .addCase(GetCheckSocialAspectSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetRelationWithSalesSlice
      .addCase(GetRelationWithSalesSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetRelationWithSalesSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.relationWithSalesList = action.payload.data;
      })
      .addCase(GetRelationWithSalesSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetBusinessAddressFlagSlice
      .addCase(GetBusinessAddressFlagSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetBusinessAddressFlagSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.businessAddressFlagList = action.payload.data;
      })
      .addCase(GetBusinessAddressFlagSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetBpkbIssuedBySlice
      .addCase(GetBpkbIssuedBySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetBpkbIssuedBySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.bpkbIssuedByList = action.payload.data;
      })
      .addCase(GetBpkbIssuedBySlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetHomeConditionService
      .addCase(GetHomeConditionSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetHomeConditionSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.homeConditionList = action.payload.data;
      })
      .addCase(GetHomeConditionSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      // GetHomeFurnishingsSlice
      .addCase(GetHomeFurnishingsSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetHomeFurnishingsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.homeFurnishingsList = action.payload.data;
      })
      .addCase(GetHomeFurnishingsSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetRoadConditionHomeService
      .addCase(GetRoadConditionHomeSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetRoadConditionHomeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.roadConditionHomeList = action.payload.data;
      })
      .addCase(GetRoadConditionHomeSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetEnvironmentalConditionsSlice
      .addCase(GetEnvironmentalConditionsSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetEnvironmentalConditionsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.environmentalConditionsList = action.payload.data;
      })
      .addCase(GetEnvironmentalConditionsSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetOfficeLocationSlice
      .addCase(GetOfficeLocationSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetOfficeLocationSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.officeLocationList = action.payload.data;
      })
      .addCase(GetOfficeLocationSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetBankIdSlice
      .addCase(GetBankIdSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetBankIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.bankIdList = action.payload.data;
      })
      .addCase(GetBankIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetAccountTypeSlice
      .addCase(GetAccountTypeSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetAccountTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.accountTypeList = action.payload.data;
      })
      .addCase(GetAccountTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetRefLoanAssessmentItemValueSlice
      .addCase(GetRefLoanAssessmentItemValueSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(
        GetRefLoanAssessmentItemValueSlice.fulfilled,
        (state, action) => {
          state.loading = false;
          state.refLoanAssessmentItemValueList = action?.payload?.data?.data;
        },
      )
      .addCase(GetRefLoanAssessmentItemValueSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      // GetCarecomendationSlice
      .addCase(GetCarecomendationSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(GetCarecomendationSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.carecomendationList = action.payload.data;
      })

      .addCase(GetCarecomendationSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //collateral reference 08062026 by triut
      .addCase(getDocumentStatus.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getDocumentStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.documentStatusList = action.payload.data;
      })
      .addCase(getDocumentStatus.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

     .addCase(getRcvFromCollateral.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getRcvFromCollateral.fulfilled, (state, action) => {
        state.loading = false;
        state.rcvFromList = action.payload.data;
      })
      .addCase(getRcvFromCollateral.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getRefInvoiceDisbDoc
      .addCase(getRefInvoiceDisbDoc.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getRefInvoiceDisbDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.refInvoiceDisbDocList = action?.payload?.data?.data || [];
      })
      .addCase(getRefInvoiceDisbDoc.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //getPaymentTerm
      .addCase(getPaymentTerm.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPaymentTerm.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentTermList = action?.payload?.data?.data || [];
      })
      .addCase(getPaymentTerm.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      .addCase(getBankAccountType.fulfilled, (state, action) => {
        state.loading = false;
        state.BankAccountTypeList = action?.payload?.data || [];
      })
      .addCase(getBankAccountType.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      .addCase(getAccountPurpose.fulfilled, (state, action) => {
        state.loading = false;
        state.AccountPurposeList = action?.payload?.data || [];
      })
      .addCase(getAccountPurpose.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      .addCase(getEBankingConnect.fulfilled, (state, action) => {
        state.loading = false;
        state.EBankingConnectList = action?.payload?.data || [];
      })
      .addCase(getEBankingConnect.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      .addCase(getResetFlag.fulfilled, (state, action) => {
        state.loading = false;
        state.ResetFlagList = action?.payload?.data || [];
      })
      .addCase(getResetFlag.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
      //end collateral reference
  },
});

export const { showNotification, hideNotification, showLoading, tesAlert } =
  reference.actions;

export default reference.reducer;
